import { render, staticRenderFns } from "./otherland.vue?vue&type=template&id=51df7f33&scoped=true&"
import script from "./otherland.vue?vue&type=script&lang=js&"
export * from "./otherland.vue?vue&type=script&lang=js&"
import style0 from "./otherland.vue?vue&type=style&index=0&id=51df7f33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51df7f33",
  null
  
)

export default component.exports